const Terms = () => {
  return <p>Terms and Conditions</p>
}

export default Terms
